/**
 * This helper function creates the methods that are required by the account's gateway router
 * Its a method to map the gateway screen switch mechanism to the composable router
 * The reason this is done here and not in the accounts package is re-usability. For example
 * websites using React Router or just the default Next Router can also use the accounts package
 * @param {Object} router - Some router
 * @param queryParamName - Name of the queryParameter used by the accounts system. For example: 'dialoog'
 * will result in urls like ?dialoog=inloggen or ?dialoog=registreren
 */
const createGatewayRouter = ({
  router: { pathname, query },
  createHref,
  removeQueryParams,
  setQueryParams,
  queryParamName,
}) => {
  const handleScreenChange = (action) => {
    if (action === 'sluiten') {
      // Navigates to the current URL, but without the given 'action'
      removeQueryParams([queryParamName]);
    } else {
      // Navigates to the current URL with the given action as queryParam
      setQueryParams({
        [queryParamName]: action,
      });
    }
  };

  // Allows the gateway to generate links to switch between screens
  const createLink = (action) => {
    const newQuery = { ...query, [queryParamName]: action };

    if (action === 'sluiten') {
      delete newQuery[queryParamName];
    }

    // Add the queryParam with the given 'action' to the current url
    const { as } = createHref({
      pathname,
      query: newQuery,
    });

    return as;
  };

  return { handleScreenChange, createLink };
};

export default createGatewayRouter;
